import { inject, ref, type InjectionKey, type Ref } from 'vue'
import { translate as translateText, type TranslationKey, type TranslationVariables } from '../../core/texts'

/** Language of the built-in fallback texts, provided by SearchResults from its `lang` prop. */
export const FALLBACK_LANG: InjectionKey<Ref<string>> = Symbol('agent-search-fallback-lang')

/**
 * `translate(key, variables)` for templates, like `@elements/translations`, with the built-in fallback texts.
 * Usage: `const translate = useTranslate()`, then `{{ translate('agent-search.search.submit') }}`.
 */
/** The language of the built-in fallback texts, as provided by SearchResults. */
export function useFallbackLang(): Ref<string> {
    return inject(FALLBACK_LANG, ref('en'))
}

export function useTranslate(): (key: TranslationKey, variables?: TranslationVariables) => string {
    const lang = useFallbackLang()

    return (key, variables) => translateText(key, lang.value, variables)
}
